import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteVenueModal = ({ isOpen, venues, isDeleting, onCancel, onConfirm }) => (
  <Modal isOpen={isOpen} toggle={onCancel} className="modal-md venues-modal">
    <ModalHeader toggle={onCancel}>
      <span className="venues-modal__title">{venues.length > 1 ? "Delete Venues" : "Delete Venue"}</span>
    </ModalHeader>
    <ModalBody className="venues-modal__body">
      <p className="venues-modal__copy">
        {venues.length > 1 ? (
          <>
            This will remove <strong>{venues.length} venues</strong> from the directory.
          </>
        ) : (
          <>
            This will remove <strong>{venues[0] && venues[0].name ? venues[0].name : "this venue"}</strong>.
          </>
        )}
      </p>
      <p className="venues-modal__helper">
        Continue only if {venues.length > 1 ? "these venues should" : "this venue should"} no longer be used in scheduling.
      </p>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
        Delete
      </Button>
    </ModalFooter>
  </Modal>
);

export default DeleteVenueModal;
